// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__5Pk9S","content":"Consent_content__kakyG","footer":"Consent_footer__3euT8"};